import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { DocumentFileTemplateKeyFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-find-many-query.dto';
import { Observable } from 'rxjs';
import { DocumentFileTemplateKeyPageInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-page.dto';
import { DocumentFileTemplateKeyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-find.dto';
import { DocumentFileTemplateKeyTargetChildrenFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-target-children-find.dto';
import type { DocumentFileTemplateKeyBriefFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-key/document-file-template-key-brief-find.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';

@Injectable({
  providedIn: 'root'
})
export class BasisDocumentFileTemplateKeyService extends BaseService {
  protected baseUrl = '/basis/catalog/document-file-template-key';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(
    queryParams?: DocumentFileTemplateKeyFindManyQueryInterface
  ): Observable<DocumentFileTemplateKeyPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<DocumentFileTemplateKeyPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findWithPagination(
    queryParams: DocumentFileTemplateKeyFindManyQueryInterface
  ): Observable<DocumentFileTemplateKeyPageInterface> {
    return this.findPage(queryParams);
  }

  public restore(id: number): Observable<DocumentFileTemplateKeyFindInterface> {
    return this.http.post<DocumentFileTemplateKeyFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getAvailableTargets(): Observable<DocumentFileTemplateKeyTargetChildrenFindInterface[]> {
    return this.http.get<DocumentFileTemplateKeyTargetChildrenFindInterface[]>(`${this.baseUrl}/get-available-targets`);
  }

  public getNumericSourceKeyCandidates(excludeKeyId?: number): Observable<DocumentFileTemplateKeyBriefFindInterface[]> {
    return this.http.get<DocumentFileTemplateKeyBriefFindInterface[]>(`${this.baseUrl}/numeric-source-key-candidates`, {
      params: typeof excludeKeyId === 'number' ? this.objectToHttpParams({ excludeKeyId }) : {}
    });
  }
}
